import { render, staticRenderFns } from "./TipoGasto.vue?vue&type=template&id=932c1cf4&"
import script from "./TipoGasto.vue?vue&type=script&lang=js&"
export * from "./TipoGasto.vue?vue&type=script&lang=js&"
import style0 from "./TipoGasto.vue?vue&type=style&index=0&id=932c1cf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports